import { useEffect, useState } from 'react';
import { fetchCompanyInfo } from '../../api';
import './About.scss';

function About() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchCompanyInfo().then((data) => {
      if (mounted) setInfo(data);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (!info) {
    return <div className="page-loading">加载中...</div>;
  }

  return (
    <div className="about">
      <section className="page-banner">
        <div className="container">
          <h1>关于我们</h1>
          <p>了解好美意的品牌故事</p>
        </div>
      </section>

      {/* 公司简介 */}
      <section className="section">
        <div className="container about-intro">
          <div className="about-intro-text">
            <h2 className="section-title left">公司简介</h2>
            <p className="about-lead">{info.intro}</p>
            <div className="about-services">
              {(info.services || []).map((s) => (
                <span className="service-tag" key={s}>{s}</span>
              ))}
            </div>
            <div className="about-facts">
              {(info.facts || []).map((f) => (
                <div className="fact-item" key={f.title}>
                  <span className="fact-icon">{f.icon}</span>
                  <div className="fact-body">
                    <h4>{f.title}</h4>
                    <p>{f.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="about-stats">
              {(info.stats || []).map((s) => (
                <div key={s.label}>
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 发展历程 */}
      <section className="section section-gray">
        <div className="container">
          <h2 className="section-title">发展历程</h2>
          <p className="section-sub">2018 - 2026，与家居市场共同生长</p>
          <div className="timeline">
            {(info.milestones || []).map((m) => (
              <div className="timeline-item" key={m.year}>
                <div className="timeline-year">{m.year}</div>
                <div className="timeline-dot" />
                <div className="timeline-event">{m.event}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
